import React from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate.min";
import { ExcelExportPropsType } from "@/types/data-table";
import { Button } from "components/ui/button";

const ExportExcel = ({
  excelData,
  fileName,
  buttonVariant = "outline",
  className,
  label = "Exporter",
  isButton = true,
  populateInExistingFile = false,
  filePath = "",
  populateFromCell = "A2",
}: ExcelExportPropsType) => {
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml. sheet; charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = async () => {
    if (populateInExistingFile && filePath) {
      const exportedFileName = fileName || filePath.split("/").pop();
      const file = await (await fetch(filePath)).arrayBuffer();
      const workbook = await XlsxPopulate.fromDataAsync(file);
      const sheet = workbook.sheet(0);
      sheet.cell(populateFromCell).value(excelData);
      const excelBuffer = await workbook.outputAsync({ type: "arraybuffer" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, exportedFileName + fileExtension);
    } else {
      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    }
  };

  return (
    <>
      {isButton ? (
        <Button variant={buttonVariant} onClick={() => exportToExcel()} className={className}>
          {label}
        </Button>
      ) : (
        <div onClick={() => exportToExcel()} className={className}>
          {label}
        </div>
      )}
    </>
  );
};

export default ExportExcel;
